import { useState, useEffect } from "react";
import { Switch } from "V2.0/common/switch";

export default function DocumentCollectionToggle({
  isEnabled,
  onToggleDocumentCollection,
}) {
  const [documentCollectionEnabled, setDocumentCollectionEnabled] =
    useState(false);

  useEffect(() => {
    setDocumentCollectionEnabled(isEnabled);
  }, [isEnabled]);

  const handleToggle = async () => {
    setDocumentCollectionEnabled(!documentCollectionEnabled);
    onToggleDocumentCollection(!documentCollectionEnabled);
  };

  return (
    <Switch
      color="emerald"
      id={`checkbox-${documentCollectionEnabled}`}
      checked={documentCollectionEnabled}
      onClick={handleToggle}
    />
  );
}
